import React, { PureComponent } from "react";
import VerticalSpace from "./components/VerticalSpace";
// import ButtonAppBar from "./components/ButtonAppBar";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Route } from "react-router-dom";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import renderRadioButtonField from "../../components/form/RadioButton";
import { reduxForm, Field } from "redux-form";
import AppConfig from "../../config/appconfig.json";
import PaypalPaymentModule from "../../components/payment/PaypalPaymentModule";
import NetsPaymentModule from "../../components/NetsPaymentModule";
import KBELogo from "../account/img/kbe-Logo-66454.png";
import Icon from "@mdi/react";
import { /*mdiSale, */mdiLoading } from "@mdi/js";
// import $ from "jquery";

class ApptPayment extends PureComponent {
  constructor(props) {
    super(props);
    const request = this.props.location.state
      ? this.props.location.state.requestForm
      : null;
    // console.log(request);
    this.state = {
      requestForm: request,
      totalAmount: request ? request.Amount : 0,
      finalAmount: request ? request.Amount : 0,
      paymentForm: "",
      isShowPaypalButton: false,
      METHOD_ENET: "0",
      METHOD_PAYPAL: "1",
      METHOD_ENET_TEXT: "eNETS",
      METHOD_PAYPAL_TEXT: "Paypal",
      PROMO_TYPE_DISCOUNT: "Percentage",
      PROMO_TYPE_VALUE: "Value",
      paymentRef: "",
      isPromoCodeLoading: false,
      isPromoCodeError: false,
      promoCodeErrorMsg: "",
      promocode: "",
      isPromoCodeApplied: false,
      netAmount: 0,
      gstAmount: 0,
      customerType: request ? request.CustomerType : "",
      paypalEnabled: AppConfig.PAYPAL_ENABLED
    };
    this.handlePostAppt = this.handlePostAppt.bind(this);
    this.handleChangePaymentMethod = this.handleChangePaymentMethod.bind(this);
    this.handleGetPromoCode = this.handleGetPromoCode.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleChangePaymentMethod(e) {
    // console.log(e[0]);
    this.setState({ paymentmethod: e[0], isShowPaypalButton: e[0] === this.state.METHOD_PAYPAL });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleProceed(event) {
    event.preventDefault();
    console.log("form submitted");
  }

  componentDidMount() {
    // console.log(this.state.requestForm);
    // const netsPaymentForm = NetsPayment.initializePayment(100);
    // console.log(netsPaymentForm);
    // this.setState({ paymentForm: netsPaymentForm });
  }

  handleGetPromoCode(event) {
    if (this.state.promocode === "" && this.state.isPromoCodeApplied) {
      const amount = this.state.totalAmount;
      const request = {
        ClientSid: this.state.requestForm.ClientSid,
        SystemSid: this.state.requestForm.SystemSid,
        DateAppt: this.state.requestForm.DateAppt,
        Slot: this.state.requestForm.Slot,
        Servicing: this.state.requestForm.Servicing,
        Amount: amount
      };
      this.setState({ isPromoCodeApplied: false, finalAmount: amount, requestForm: request });
    }
    else if (this.state.requestForm) {
      this.setState({ isPromoCodeLoading: true, isPromoCodeError: false });
      let isGetPromoCodeFailed = false;
      // Call Back-End Services
      const value = this.state.totalAmount;
      const custId = this.state.requestForm.ClientSId;
      const promocode = this.state.promocode;
      let listOfServicingPrice = "";
      for (let i = 0; i < this.state.requestForm.Servicing.length; i++) {
        listOfServicingPrice += this.state.requestForm.Servicing[i].ServicingPriceSid;
        if (i < this.state.requestForm.Servicing.length - 1) {
          listOfServicingPrice += ",";
        }
      }

      fetch(
        `${AppConfig.BACK_END_URL}/APIClient/GetPromoCode?customerId=` + custId + `&paymentValue=` + value + `&promoCode=` + promocode + `&listOfServicingPrice=` + listOfServicingPrice
      )
        .then(response => {
          if (response.ok === false) {
            isGetPromoCodeFailed = true;
          }
          return response.json();
        })
        .then(json => {
          const respObj = JSON.parse(json);
          if (isGetPromoCodeFailed) {
            // console.log(respObj.Message);
            this.setState({ promoCodeErrorMsg: respObj.Message, isPromoCodeError: true });
          }
          else {
            if (!this.state.isPromoCodeApplied && respObj.length > 0) {
              if (respObj[0].DiscountType === this.state.PROMO_TYPE_DISCOUNT) {
                const netAmt = this.state.totalAmount - ((respObj[0].DiscountValue / 100) * this.state.totalAmount);
                const gstAmt = 0.07 * netAmt;
                const finAmount = netAmt + gstAmt;
                const request = {
                  ClientSid: this.state.requestForm.ClientSid,
                  SystemSid: this.state.requestForm.SystemSid,
                  DateAppt: this.state.requestForm.DateAppt,
                  Slot: this.state.requestForm.Slot,
                  Servicing: this.state.requestForm.Servicing,
                  Amount: finAmount
                };
                this.setState({ isPromoCodeApplied: true, finalAmount: finAmount, requestForm: request, netAmount: netAmt, gstAmount: gstAmt });
              }
              else if (respObj[0].DiscountType === this.state.PROMO_TYPE_VALUE) {
                const netAmt = this.state.totalAmount - respObj[0].DiscountValue;
                const gstAmt = 0.07 * netAmt;
                const finAmount = netAmt + gstAmt;
                const request = {
                  ClientSid: this.state.requestForm.ClientSid,
                  SystemSid: this.state.requestForm.SystemSid,
                  DateAppt: this.state.requestForm.DateAppt,
                  Slot: this.state.requestForm.Slot,
                  Servicing: this.state.requestForm.Servicing,
                  Amount: finAmount
                };
                this.setState({ isPromoCodeApplied: true, finalAmount: finAmount, requestForm: request, netAmount: netAmt, gstAmount: gstAmt });
              }
            }
          }
          this.setState({ isPromoCodeLoading: false });
        })
        .catch(() => {
          console.log("error");
          this.setState({ isPromoCodeLoading: false });
        });
    }
    else {

    }
  }

  handlePostAppt(history, ref) {
    /*
    ClientSId: "20181107IMRcfwfuT6SN"
    DateAppt: "13/02/2019"
    Servicing: Array(1)
      0:
      ServiceCategory: "Annual Contract (4 Servicing)"
      ServiceUnit: "1"
      ServicingPriceSid: "201809304R0baHi5jr3O"
    Slot: "09:00 AM to 09:30 AM"
    SystemSid: "20181107IQIbIPjmaaI2"
    Amount: "160.00"
    */
    if (this.state.requestForm) {
      let promoCode = "";
      if (this.state.isPromoCodeApplied)
        promoCode = this.state.promocode;

      let amountFloat = parseFloat(this.state.requestForm.Amount);
      let amountStr = amountFloat.toFixed(2).toString();

      const requestForm = {
        ClientSid: this.state.requestForm.ClientSid,
        SystemSid: this.state.requestForm.SystemSid,
        DateAppt: this.state.requestForm.DateAppt,
        Slot: this.state.requestForm.Slot,
        Servicing: this.state.requestForm.Servicing,
        Amount: amountStr,
        PromoCode: promoCode,
        PaymentMode: this.state.METHOD_PAYPAL_TEXT
      };

      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestForm)
      };
      let isPOSTApptFailed = false;
      // Call Back-End Services
      fetch(`${AppConfig.BACK_END_URL}/APIAppt/POSTAppt`, request)
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isPOSTApptFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isPOSTApptFailed) {
          } else {
            const respObj = JSON.parse(json);
            // console.log(respObj);
            if (respObj) {
              history.push({
                pathname: "/confirmation",
                state: { requestForm: requestForm, paymentRef: ref }
              });
            }
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when submitting appointment. Please try again."
          );
        });
    }
  }

  render() {
    // const ProceedButton = props => (
    //   <Route
    //     render={({ history }) => (
    //       <div>
    //         <Button
    //           variant="outlined"
    //           style={{ width: "100%" }}
    //           onClick={() => {
    //             this.handlePostAppt(history);
    //           }}
    //         >
    //           Proceed
    //         </Button>
    //       </div>
    //     )}
    //   />
    // );

    // const ProceedButtonPaypal = props => (
    //   <Route
    //     render={({ history }) => (
    //       <div>
    //         <Button
    //           variant="outlined"
    //           style={{ width: "100%" }}
    //           onClick={() => {
    //             /*
    //             var popup = window.open('', 'TheWindow');
    //             document.getElementById('paypal-payment-form').submit();
    //             */
    //             $('#appt').val(JSON.stringify(this.state.requestForm));
    //             $('#paypal-payment-form').submit();

    //             window.addEventListener('message', updatePaymentStatus);
    //             function updatePaymentStatus(e) {
    //               //alert(e);
    //               //alert(e.data);
    //               // document.querySelector("#username").innerText = e.data.username;
    //               // document.querySelector("#password").innerText = e.data.password;
    //               // popup.close();
    //             }
    //           }}
    //         >
    //           Proceed with Paypal
    //         </Button>
    //       </div>
    //     )}
    //   />
    // );

    const PromoCodeErrorMessage = props => {
      if (this.state.isPromoCodeError) {
        return (
          <span className="form__form-group-field list-text-red">
            {this.state.promoCodeErrorMsg}
          </span>
        );
      }
      return null;
    };

    return (
      <div>
        {/* <ButtonAppBar /> */}
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Payment</h4>
                </center>
                <br />
              </div>
              <form
                className="form form--horizontal"
                onSubmit={this.handleProceed}
              >
                <div className="form__form-group">
                  <label className="form__form-group-label">Amount: </label>
                  <div className="form__form-group-field">
                    <label className="form__form-group-label">
                      <b>$ {this.state.totalAmount}</b>
                    </label>
                  </div>
                </div>
                <div className="form__form-group">
                  <label className="form__form-group-label">Promo Code? </label>
                  <div className="form__form-group-field">
                    <input
                      id="promocode"
                      name="promocode"
                      type="text"
                      placeholder="Promo Code"
                      value={this.state.promocode}
                      onChange={this.handleInputChange}
                    // className="clearable"
                    // disabled={this.state.isPromoCodeApplied}
                    />
                    <div id="clear"
                      onClick={() => {
                        this.setState({ promocode: "" });
                      }}>x</div>
                    <div>
                      {this.state.isPromoCodeLoading ? (
                        <div
                          className="form__form-group-icon">
                          <Icon path={mdiLoading} spin={1} /></div>
                      ) : (
                        <Button variant="outlined" size="small" onClick={this.handleGetPromoCode}>Apply</Button>
                      )}
                    </div>
                  </div>
                  <PromoCodeErrorMessage />
                </div>
                {this.state.isPromoCodeApplied ? (
                  <div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">Net Amount: </label>
                      <div className="form__form-group-field">
                        <label className="form__form-group-label">
                          <b>$ {this.state.netAmount.toFixed(2)}</b>
                        </label>
                      </div>
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">GST: </label>
                      <div className="form__form-group-field">
                        <label className="form__form-group-label">
                          <b>$ {this.state.gstAmount.toFixed(2)}</b>
                        </label>
                      </div>
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">Final Amount: </label>
                      <div className="form__form-group-field">
                        <label className="form__form-group-label">
                          <b>$ {this.state.finalAmount.toFixed(2)}</b>
                        </label>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="form__form-group">
                  <label className="form__form-group-label">
                    Payment Option
                  </label>
                  <div className="form__form-group-field">
                    {this.state.customerType === "Commercial" ?
                      <Field
                        name="paymentoption"
                        component={renderRadioButtonField}
                        label={this.state.METHOD_ENET_TEXT}
                        radioValue={this.state.METHOD_ENET}
                        onChange={this.handleChangePaymentMethod}
                        defaultChecked
                      />
                      : null}
                    {this.state.paypalEnabled ?
                      <Field
                        name="paymentoption"
                        component={renderRadioButtonField}
                        label={this.state.METHOD_PAYPAL_TEXT}
                        radioValue={this.state.METHOD_PAYPAL}
                        onChange={this.handleChangePaymentMethod}
                      />
                      : null}
                  </div>
                </div>
                <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={3} />
                    <Grid item xs={6}>
                      {this.state.isShowPaypalButton ? (
                        <Route
                          render={({ history }) => (
                            <PaypalPaymentModule isShowPaypalButton={this.state.isShowPaypalButton}
                              totalAmount={this.state.totalAmount} customerType={this.state.customerType}
                              onPaymentSuccess={(data) => {
                                // console.log("Paypal payment received");
                                // console.log(data);
                                this.handlePostAppt(history, data);
                              }}></PaypalPaymentModule>)}
                        />) : (
                        this.state.CustomerType === "Commercial" ?
                          <NetsPaymentModule txnAmount={this.state.totalAmount} requestForm={this.state.requestForm} isInvoicePayment={false} />
                          : null
                        // <span></span>
                        //<ProceedButton />
                        // <ProceedButtonPaypal />
                      )}
                    </Grid>
                    <Grid item xs={3} />
                  </Grid>
                </div>
                {/* <form id="paypal-payment-form" action="https://kbe-uat.aquilalogic.com.sg/payment.aspx" method="post" target="my-iframe">
                  <input type="hidden" name="appt" id="appt" value="" />
                </form>
                <iframe name="my-iframe" src="https://kbe-uat.aquilalogic.com.sg/payment.aspx" width="100%" height="600px"></iframe> */}
                <VerticalSpace />
              </form>
              <SimpleBottomNavigation value={1} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "payment_form" // a unique identifier for this form
})(ApptPayment);



// WEBPACK FOOTER //
// ./src/pages/main/ApptPayment.js